window.onload = () => {
    //write your code here


mapboxgl.accessToken = 'pk.eyJ1IjoiYmVub2FtZXViZWxzIiwiYSI6ImNtazB3enc1cTFvZDkzZHIybGxtb3hwMnEifQ.3aQD-ZkukUdsQEpLG1vgWA';

      /**
       * Add the map to the page
       */
      const map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v12', // generic test style

//        style: 'mapbox://styles/benoameubels/cmkbjgjkm00by01sch5i8d9vi',
        center: [4.410321,52.307425],
        zoom: 7,
        scrollZoom:true,
        maxZoom: 14,
        minZoom:5

        // center: [5.1097865,52.089248999999995],
        
        
    });

    const nav = new mapboxgl.NavigationControl({
// visualizePitch: false,
// showCompass:false
      
});

  
  map.addControl(new mapboxgl.NavigationControl());




  
    const stores = {
      "type": "FeatureCollection",
      "features": [
        
           { //Appels Design
            "type": "Feature",
            "geometry": {
              "type": "Point", 
              "coordinates": [6.845230, 52.221370]},
            "properties": {
              "name":"Appels Design",
              "phoneFormatted": "+31 622 402 880",
              "phone": "+31622402880",
              "address": "De Ossenboer 26",
              "city": "Enschede",
              "country": "Netherlands",
              "postalCode": "7547 SJ",
              "state": "Overijssel",
              "web":"www.appelsdesign.nl"
            }
          },

        
           { //Arc Living
             "type": "Feature",
            "geometry": {
              "type": "Point", 
              "coordinates": [5.943806, 51.878482]},
            "properties": {
              "name":"Arc Living",
              "phoneFormatted": "+31 622 993 131",
              "phone": "+31622993132",
              "address": "Langstraat 277",
              "city": "Gendt",
              "country": "Netherlands",
              "postalCode": "6691 EE",
              "state": "Overijssel",
              "web":"www.arc-living.nl"
            }
          },

          { //ASN Nature & Living 
         "type": "Feature",
            "geometry": {
             "type": "Point", 
              "coordinates": [5.1737692, 52.3918513]},
             "properties": {
               "name":"ASN Nature & Living",
               "phoneFormatted": "+31 610 950 958",
               "phone": "+31610950958",
               "address": "Loggerzeil 1",
               "city": "Almere",
               "country": "Netherlands",
               "postalCode": "1319 EA",
               "state": "Noord-Holland",
               "web":"www.asnnatureandliving.nl"
             }
           },

        
         { //ASN Nature & Living / Loods 5 / Zaandam
             "type": "Feature",
             "geometry": {
               "type": "Point", 
               "coordinates": [4.8240436, 52.4295682]},
             "properties": {
               "name":"ASN Nature & Living / Loods 5",
               "phoneFormatted": "+31 610 950 958",
               "phone": "+31610950958",
               "address": "Pieter Ghijsenlaan 14b",
               "city": "Zaandam",
               "country": "Netherlands",
               "postalCode": "1506 PV",
               "state": "Noord-Holland",
               "web":"www.asnnatureandliving.nl"
             }
           },

       

        // { //ASN Nature & Living  / Loods 5 / Sliedrecht
        //     "type": "Feature",
        //     "geometry": {
        //       "type": "Point", 
        //       "coordinates": [5.4098712, 52.1906543]},
        //     "properties": {
        //       "name":"ASN Nature & Living / Loods 5",
        //       "phoneFormatted": "+31 610 950 958",
        //       "phone": "+31610950958",
        //       "address": "Leeghwaterstraat 69",
        //       "city": "Sliedrecht",
        //       "country": "Netherlands",
        //       "postalCode": "3364 AE",
        //       "state": "Zuid-Holland",
        //       "web":"www.asnnatureandliving.nl"
        //     }
        //   },
        
        
        
        // { //ASN Nature & Living  / Loods 5 / Amersfoort
        //     "type": "Feature",
        //     "geometry": {
        //       "type": "Point", 
        //       "coordinates": [4.7603366, 51.8298986]},
        //     "properties": {
        //       "name":"ASN Nature & Living / Loods 5",
        //       "phoneFormatted": "+31 610 950 958",
        //       "phone": "+31610950958",
        //       "address": "Euroweg 1",
        //       "city": "Amersfoort",
        //       "country": "Netherlands",
        //       "postalCode": "3825 AA",
        //       "state": "Utrecht",
        //       "web":"www.asnnatureandliving.nl"
        //     }
        //   },

    
        // { //ASN Nature & Living  / Loods 5 / Maastricht
        //     "type": "Feature",
        //     "geometry": {
        //       "type": "Point", 
        //       "coordinates": [5.6875868, 50.8572141]},
        //     "properties": {
        //       "name":"ASN Nature & Living / Loods 5",
        //       "phoneFormatted": "+31 610 950 958",
        //       "phone": "+31610950958",
        //       "address": "Sphinxcour 5",
        //       "city": "Maastricht",
        //       "country": "Netherlands",
        //       "postalCode": "6211 XZ",
        //       "state": "Limburg",
        //       "web":"www.asnnatureandliving.nl"
        //     }
        //   },


    { //B&G Meubelen
            "type": "Feature",
            "geometry": {
              "type": "Point", 
              "coordinates": [6.0475425, 52.3447941]},
            "properties": {
              "name":"B&G Meubelen",
              "phoneFormatted": "+31 578 641 200",
              "phone": "+31578641200",
              "address": "Houtweg 18",
              "city": "Oene",
              "country": "Netherlands",
              "postalCode": "8167 PL",
              "state": "Gelderland",
              "web":"www.bengmeubelen.nl"
            }
          },


    { //Bergsma Meubelen
            "type": "Feature",
            "geometry": {
              "type": "Point", 
              "coordinates": [6.0566083, 53.0107877]},
            "properties": {
              "name":"Bergsma Meubelen",
              "phoneFormatted": "+31 64 244 892",
              "phone": "+3164 44892",
              "address": "Overtoom 4",
              "city": "Gorredijk",
              "country": "Netherlands",
              "postalCode": "8401 JD",
              "state": "Friesland",
              "web":"www.bergsmameubelen.nl"
            }
          },


        
        { //Brouwer Meubelen
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [4.814485, 52.664465]},
          "properties": {
            "name":"Brouwer Meubelen",
            "phoneFormatted": "+31 725 741 160",
            "phone": "+31725741160",
            "address": "G. Rietveldweg 3",
            "city": "Heerhugowaard",
            "country": "Netherlands",
            "postalCode": "1703 DD",
            "state": "Noord-Holland",
            "web":"www.brouwermeubelen.nl"
          }
        },


       { //Budget Home Store Winterswijk
            "type": "Feature",
            "geometry": {
              "type": "Point", 
              "coordinates": [6.7049564, 51.9719195]},
            "properties": {
              "name":"Budget Home Store Winterswijk",
              "phoneFormatted": "+31 543 515 296",
              "phone": "+31543515296",
              "address": "Europalaan 107",
              "city": "Winterswijk",
              "country": "Netherlands",
              "postalCode": "7102 AC",
              "state": "Gelderland",
              "web":"www.budgethomestore.nl"
            }
          },


        { //C & T Meubelen
            "type": "Feature",
            "geometry": {
              "type": "Point", 
              "coordinates": [4.5925066, 52.2859761]},
            "properties": {
              "name":"C & T Meubelen",
              "phoneFormatted": "+31 252 525 290",
              "phone": "+31252525290",
              "address": "Hillegommerdijk 325",
              "city": "Beinsdorp",
              "country": "Netherlands",
              "postalCode": "2144 KR",
              "state": "Noord-Holland",
              "web":"www.centmeubelen.nl"
            }
          },


        { // Cavetown
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.103926, 52.01547]},
          "properties": {
            "name":"Cavetown",
            "phoneFormatted": "+31 850 470 391",
            "phone": "+31850470391",
            "address": "Montageweg 11",
            "city": "Nieuwegein",
            "country": "Netherlands",
            "postalCode": "3433 NT",
            "state": "Utrecht",
            "web":"www.cavetown.nl"
          }
        },

        { //Cosy Gifts & Living 
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.1854160, 53.1752203]},
          "properties": {
            "name":"Cosy Gifts & Living ",
            "phoneFormatted": "+31 629 314 479",
            "phone": "+31629314479",
            "address": "De Wending 5",
            "city": "Opende",
            "country": "Netherlands",
            "postalCode": "9865 VC",
            "state": "Groningen",
            "web":"www.cosy-opende.nl"
          }
        },

        
        { //De Echo Wonen & Slapen
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.4187502, 51.4143598]},
          "properties": {
            "name":"De Echo Wonen & Slapen",
            "phoneFormatted": "+31 402 536 377",
            "phone": "+31402536377",
            "address": "Provincialeweg 65",
            "city": "Veldhoven",
            "country": "Netherlands",
            "postalCode": "5503 HB",
            "state": "Noord-Brabant",
            "web":"www.deecho.nl"
          }
        },

        
        { //Dekker Meubelen
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.9566862, 52.2133158]},
          "properties": {
            "name":"Dekker Meubelen",
            "phoneFormatted": "+31 555 214 087",
            "phone": "+31555214087",
            "address": "Asselsetstraat 53",
            "city": "Apeldoorn",
            "country": "Netherlands",
            "postalCode": "7311 ED",
            "state": "Gelderland",
            "web":"www.dekkermeubelen.nl"
          }
        },
        

        { //De Meubelstunter
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.9173207, 52.7708552]},
          "properties": {
            "name":"De Meubelstunter",
            "phoneFormatted": "+31 651 555 269",
            "phone": "+31651555269",
            "address": "Kapitein Grantstraat 32",
            "city": "Emmen",
            "country": "Netherlands",
            "postalCode": "7821 AR",
            "state": "Drenthe",
          }
        },

        
        { //De Tuin van Eden
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [4.5806245, 51.3904614]},
          "properties": {
            "name":"De Tuin van Eden",
            "phoneFormatted": "+32 476 638 526",
            "phone": "+32476638526",
            "address": "Kalmhoutsesteenweg 112",
            "city": "Wuustwezel",
            "country": "Belgium",
            "postalCode": "2990",
            "web":"www.detuinvaneden.com"
          }
        },
     
        { //De Pottentuin
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [4.7401152, 51.3023005]},
          "properties": {
            "name":"De Pottentuin",
            "phoneFormatted": "+32 485 570 248",
            "phone": "+32485870248",
            "address": "Blijkerijstraat 63",
            "city": "Malle",
            "country": "Belgium",
            "postalCode": "2390",
            "web":"www.depottentuin.be"
          }
        },


        { //De Woonhoek
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.4753935, 51.4686718]},
          "properties": {
            "name":"De Woonhoek",
            "phoneFormatted": "+31 402 871 200",
            "phone": "+31402871200",
            "address": "Winkelcentrum Woensel 342",
            "city": "Eindhoven",
            "country": "Netherlands",
            "postalCode": "5625 AG",
            "state": "Noord-Brabant",
            "web":"www.dewoonhoek.nl"
          }
        },


        { //Dilay Wonen en Slapen
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.4771163, 51.4517946]},
          "properties": {
            "name":"Dilay Wonen en Slapen",
            "phoneFormatted": "+31 40 751 0043",
            "phone": "+31407510043",
            "address": "Veldmaarschalk Montgomerylaan 669",
            "city": "Eindhoven",
            "country": "Netherlands",
            "postalCode": "5612 BP",
            "state": "Noord-Brabant",
            "web":"www.dilaywonen.nl"
          }
        },

         { //Donders Meubelen
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.090690, 51.553010]},
          "properties": {
            "name":"Donders Meubelen",
            "phoneFormatted": "013-5434066",
            "phone": "013-5434066",
            "address": "Koopvaardijstraat 40",
            "city": "Tilburg",
            "country": "Netherlands",
            "postalCode": "5017 BG",
            "state": "Noord-Brabant",
            "web":"www.dondersmeubel.nl"
          }
        },

        

        { //EPD Meubels
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [4.5851819, 51.5683623]},
          "properties": {
            "name":"EPD Meubels",
            "phoneFormatted": "+31 615 254 70",
            "phone": "+3161525470",
            "address": "Korte Bunder 17",
            "city": "Hoeven",
            "country": "Netherlands",
            "postalCode": "4741 TV",
            "state": "Noord-Brabant",
            "web":"www.epdmeubels.nl"
          }
        },
        
        
        { //Fameus wonen
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [4.7691588, 52.9449879]},
          "properties": {
            "name":"Fameus wonen",
            "phoneFormatted": "+31 223 634 910",
            "phone": "+31223634910",
            "address": "Industrieweg 7",
            "city": "Den Helder",
            "country": "Netherlands",
            "postalCode": "1785 AG",
            "state": "Noord-Holland",
            "web":"www.fameuswonen.nl"
          }
        },

        { //Frenque Interiors BV
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [7.0098487, 52.2503525]},
          "properties": {
            "name":"Frenque Interiors",
            "phoneFormatted": "+31 534 368 173",
            "phone": "+31534368173",
            "address": "Nijverheidstraat 11",
            "city": "Losser",
            "country": "Netherlands",
            "postalCode": "7581 PV",
            "state": "Overijssel",
            "web":"www.frenque.nl"
      
          }
        },

        { //Gert Willigenburg Wonen & Lifestyle
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.4817452, 52.2369598]},
          "properties": {
            "name":"Gert Willigenburg Wonen & Lifestyle",
            "phoneFormatted": "+31 337 410 220",
            "phone": "+31337410220",
            "address": "Handelsweg 30",
            "city": "Putten",
            "country": "Netherlands",
            "postalCode": "3881 LS",
            "state": "Gelderland",
            "web":"www.gertwilligenburg.nl"
          }
        },

        { //geWOON!
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.9177805, 52.5571443]},
          "properties": {
            "name":"geWOON!",
            "phoneFormatted": "+31 820 202 627",
            "phone": "+31820202627",
            "address": "Oudestraat 76",
            "city": "Kampen",
            "country": "Netherlands",
            "postalCode": "8261 CT",
            "state": "Overijssel",
            "web":"www.gewoonkampen.nl"
          }
        },



        { //Goedkoopste woonwinkel
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [4.7551329, 51.8316504]},
          "properties": {
            "name":"Goedkoopste Woonwinkel",
            "phoneFormatted": "+31 648 646 376",
            "phone": "+31648646376",
            "address": "Marisstraat 12",
            "city": "Sliedrecht",
            "country": "Netherlands",
            "postalCode": "3364 AZ",
            "state": "Zuid-Holland",
            "web":"www.goedkoopstewoonwinkel.nl"
          }
        },


        { //GSM Wonen en Slapen
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.5437170, 52.2980581]},
          "properties": {
            "name":"GSM Wonen en Slapen",
            "phoneFormatted": "+31 548 517 306",
            "phone": "+31548517306",
            "address": "Enterstraat 200",
            "city": "Rijssen",
            "country": "Netherlands",
            "postalCode": "7461 PE",
            "state": "Overijssel"
          
          }
        },

       { //Harrie XL
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.0249274, 51.2048352]},
          "properties": {
            "name":"Harrie XL Outlet",
            "phoneFormatted": "+31 493 697 211",
            "phone": "+31493697211",
            "address": "Sint Wirosingel 194",
            "city": "Roermond",
            "country": "Netherlands",
            "postalCode": "6042 KZ",
            "state": "Limburg",
            "web":"www.webshop.harriexloutlet.nl"
          }
        },


        { //Het Teakmagazijn
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [4.6639593, 52.0252947]},
          "properties": {
            "name":"Het Teakmagazijn",
            "phoneFormatted": "+31 627 627 005",
            "phone": "+31627627005",
            "address": "Kanaaldijk 32a",
            "city": "Waddinxveen",
            "country": "Netherlands",
            "postalCode": "2741 PA",
            "state": "Zuid-Holland",
            "web":"www.teakmagazijn.nl"
          }
        },
        
         { //Home Destock
           "type": "Feature",
           "geometry": {
             "type": "Point", 
             "coordinates": [3.3969601, 50.373776]},
           "properties": {
             "name":"Home Destock",
             "phoneFormatted": "+32 51 302 000",
             "phone": "+339 88 50 41 17",
             "address": "Meensesteenweg 51",
             "city": "Wallers",
             "country": "France",
             "postalCode": "59135",
             "state": "",
             "web":""
           }
         },
        

        { //Houten Meubel Outlet
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [4.8924402, 52.7611081]},
          "properties": {
            "name":"Houten Meubel Outlet",
            "phoneFormatted": "+31 224 850 926",
            "phone": "+31224850926",
            "address": "Zandwilg 21-22",
            "city": "Winkel",
            "country": "Netherlands",
            "postalCode": "1731 LS",
            "state": "Noord-Holland",
            "web":"www.houtenmeubeloutlet.nl"
          }
        },


        { //Intens Wonen
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.185530, 51.585040]},
          "properties": {
            "name":"Intens Wonen",
            "phoneFormatted": "+31 852 010 242",
            "phone": "+31852010242",
            "address": "Sprendlingenstraat 9",
            "city": "Oisterwijk",
            "country": "Netherlands",
            "postalCode": "5061 KM",
            "state": "Noord-Brabant",
            "web":"www.intenswonen.nl"
          }
        },

        { //Interieurhuus op Ees
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.8022901, 52.9055842]},
          "properties": {
            "name":"Interieurhuus op Ees",
            "phoneFormatted": "+31 655 372 935",
            "phone": "+31655372935",
            "address": "Schoolstraat 8",
            "city": "Ees",
            "country": "Netherlands",
            "postalCode": "9536 TC",
            "state": "Drenthe"
          }
        },


         { //Koopcentrum 't Zuid
           "type": "Feature",
           "geometry": {
             "type": "Point", 
             "coordinates": [6.0985960, 53.0871330]},
           "properties": {
             "name":"Koopcentrum 't Zuid",
             "phoneFormatted": "+31 512 512 156",
             "phone": "+31 512 512 156",
             "address": "Het Zuid 24a",
             "city": "Drachten",
             "country": "Netherlands",
             "postalCode": "9203 TD",
             "state": "Friesland",
             "web":"www.koopcentrumhetzuid.nl"
           }
         },




        { //Kospa Living
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.6428076, 52.3405673]},
          "properties": {
            "name":"Kospa Living",
            "phoneFormatted": "+31 546 648 003",
            "phone": "+31546648003",
            "address": "Woonboulevard 18",
            "city": "Almelo",
            "country": "Netherlands",
            "postalCode": "7606 JA",
            "state": "Gelderland",
            "web":"www.kospa.nl"
          }
        },

       { //L’ abcd’ aire
           "type": "Feature",
           "geometry": {
             "type": "Point", 
             "coordinates": [2.393264, 50.6568626]},
           "properties": {
             "name":"L’ abcd’ aire",
             "phoneFormatted": "+33 3 21 12 65 80",
             "phone": "+33 3 21 12 65 80",
             "address": "Route departementale 943 RD",
             "city": "Aire-sur-la-lys",
             "country": "France",
             "postalCode": "62120",
             "state": "",
             "web":"www.abcd-aire.fr/"
           }
         },

                    
        { //Les Brocanteurs
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.4314443, 52.5281006]},
          "properties": {
            "name":"Les Brocanteurs",
            "phoneFormatted": "+31 653 107 183",
            "phone": "+31653107183",
            "address": "Slagenkampweg 5",
            "city": "Ommen",
            "country": "Netherlands",
            "postalCode": "7731 TK",
            "state": "Overijssel",
            "web":"www.lesbrocanteurs.nl" 
          }
        },


        { //Lito Meubelen
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.8669701, 52.2194398]},
          "properties": {
            "name":"Lito Meubelen",
            "phoneFormatted": "+31 629 581 125",
            "phone": "+31653107183",
            "address": "Parkweg 155",
            "city": "Enschede",
            "country": "Netherlands",
            "postalCode": "7545 MV",
            "state": "Overijssel",
            "web":"www.leukemeubels.nl"
          }
        },



        
        { //Loft16 
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [3.9909176,51.2730394]},
          "properties": {
            "name":"Loft16",
            "phoneFormatted": "+31 646 712 564 ",
            "phone": "+31646712564",
            "address": "Industrieweg 2 ",
            "city": "Hulst",
            "country": "Netherlands",
            "postalCode": "4561 GH",
            "state": "Zeeland",
            "web":"www.loft16.nl"
          }
        },



         { //Mangohoutenmeubels
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [4.6424006, 52.37050817]},
          "properties": {
            "name":"Mangohoutenmeubels",
            "phoneFormatted": "+31 614 161 242",
            "phone": "+31 614 161 242",
            "address": "Clothildestraat 267",
            "city": "Haarlem",
            "country": "Netherlands",
            "postalCode": "2033 LW",
            "state": "Noord-Holland",
            "web":"www.mangohoutenmeubels.nl"
          }
        },

        
       { // Met Meubels
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [4.6635907, 51.8084264]},
          "properties": {
            "name":"Met Meubels",
            "phoneFormatted": "+31 622 078 616",
            "phone": "+31622078616",
            "address": "Burg. de Raadsingel 95a",
            "city": "Dordrecht",
            "country": "Netherlands",
            "postalCode": "3311 JG",
            "state": "Zuid-Holland",
            "web":"www.metmeubels.nl"
          }
        },


        { //Meubel en Decoratiehuis Groesbeek
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.934090 ,51.781710]},
          "properties": {
            "name":"Meubel en Decoratiehuis Groesbeek",
            "phoneFormatted": "+31247853543",
            "phone": "-31247853543",
            "address": "Molenweg 4",
            "city": "Groesbeek",
            "country": "Netherlands",
            "postalCode": "6561 AJ",
            "state": "Gelderland",
            "web":"www.meubelendecoratiegroesbeek.nl"
          }
        },

        { //Meubel Outletstore Veendam
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.8869147, 53.1047927]},
          "properties": {
            "name":"Meubel Outletstore Veendam",
            "phoneFormatted": "+31 625 211 980",
            "phone": "+31625211980",
            "address": "Spoorweg 10a",
            "city": "Veendam",
            "country": "Netherlands",
            "postalCode": "9641 KH",
            "state": "Groningen"
          }
        },


        { //Meubelbaas
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.9721550, 52.2263190]},
          "properties": {
            "name":"Meubelbaas",
            "phoneFormatted": "+31 850 608 569",
            "phone": "+31850608569",
            "address": "Vlijtseweg  134-HAL18",
            "city": "Apeldoorn",
            "country": "Netherlands",
            "postalCode": "7317 AK",
            "state": "Groningen",
            "web":"www.meubelbaas.nl"
          }
        },

       { //Meubelplaats.nl
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.1589286, 52.2641297]},
          "properties": {
            "name":"Meubelplaats.nl",
            "phoneFormatted": "+31 570 763 763",
            "phone": "+31570763763",
            "address": "Ceintuurbaan 209",
            "city": "Deventer",
            "country": "Nederland",
            "postalCode": "7413 DE",
            "state": "Overijssel",
            "web":"www.meubelplaats.nl"
          }
        },

   { //Meubelstudio van Haren
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.9483645, 51.6488097]},
          "properties": {
            "name":"Meubelstudio van Haren ",
            "phoneFormatted": "+31 485 575 146",
            "phone": "+31485575146",
            "address": "De Reatsingel 2A",
            "city": "Boxmeer",
            "country": "Netherlands",
            "postalCode": "5831 KC",
            "state": "Noord-Brabant",
            "web":"www.meubelstudiovanharen.nl"
          }
        },

        

        { //Mokana Meubelen
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.9098070, 52.2145952]},
          "properties": {
            "name":"Mokana Meubelen",
            "phoneFormatted": "+31 534 335 032",
            "phone": "+31534335032",
            "address": "Hogelandsingel 49",
            "city": "Enschede",
            "country": "Netherlands",
            "postalCode": "7512 GB",
            "state": "Overijssel",
            "web":"www.mokana.nl"
          }
        },


        { //Onje Clonje
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.6683143, 51.4946036]},
          "properties": {
            "name":"Onje Clonje",
            "phoneFormatted": "+31 655 851 972",
            "phone": "+31655851972",
            "address": "Nieuwveld 49B",
            "city": "Helmond",
            "country": "Netherlands",
            "postalCode": "5702 HW",
            "state": "Utrecht"
          }
        },


        { //Onze Teakhoek
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.1025106, 52.0627556]},
          "properties": {
            "name":"Onze Teakhoek",
            "phoneFormatted": "+31 302 805 035",
            "phone": "+31302805035",
            "address": "Zeelantlaan 25",
            "city": "Utrecht",
            "country": "Netherlands",
            "postalCode": "3526 AK",
            "state": "Utrecht",
            "web":"www.onzeteakhoek.nl"
          }
        },

        
        { //Peerz Living & Lifestyle
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.4467282, 51.6069951]},
          "properties": {
            "name":"Peerz Living & Lifestyle",
            "phoneFormatted": "+31 733 030 078",
            "phone": "+31733030078",
            "address": "Rooiseweg 1",
            "city": "Schijndel",
            "country": "Netherlands",
            "postalCode": "5481 SJ",
            "state": "Noord-Brabant"
          }
        },


        { //Polder Teak
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.7062722, 52.4610782]},
          "properties": {
            "name":"Polder Teak",
            "phoneFormatted": "+31 636 002 627",
            "phone": "+31636002627",
            "address": "Ploegschaar 52A",
            "city": "Biddinghuizen",
            "country": "Netherlands",
            "postalCode": "8526 SM",
            "state": "Flevoland",
            "web":"www.polderteak.nl"
          }
        },

       { //Pura Vida
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [-1.0405572, 38.3984242]},
          "properties": {
            "name":"Pura Vida",
            "phoneFormatted": "+34 685616030",
            "phone": "+34685616030",
            "address": "Calle Principe de Asturias 10C",
            "city": "Pinoso",
            "country": "Spain",
            "postalCode": "03650",
            "web":"www.puravidapinoso.eu"
          }
        },


        { //Reas Wonen
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.691670, 52.749780]},
          "properties": {
            "name":"REAS WONEN",
            "phoneFormatted": "+31 524 504 040",
            "phone": "+31524504040",
            "address": "Dorpstraat 23",
            "city": "Gees",
            "country": "Netherlands",
            "postalCode": "7863 PA",
            "state": "Drenthe",
            "web":"www.reaswonen.nl"
          }
        },

     
        
        { //Ries Meubelen
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.3934938, 52.1618302]},
          "properties": {
            "name":"Ries Meubelen",
            "phoneFormatted": "+31 334 720 067",
            "phone": "+31334720067",
            "address": "Van Brakelstraat 4",
            "city": "Amersfoort",
            "country": "Netherlands",
            "postalCode": "3814 RK",
            "state": "Utrecht",
            "web":"www.riesmeubelen.nl"
          }
        },

        
        { //Rimeni Creatief
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.8669335, 50.9979056]},
          "properties": {
            "name":"Rimeni Creatief",
            "phoneFormatted": "+31 612 653 539",
            "phone": "+31612653539",
            "address": "Walstraat 37",
            "city": "Sittard",
            "country": "Netherlands",
            "postalCode": "6131 CV",
            "state": "Limburg",
            "web":"www.rimenicreatief.nl"
          }
        },

        
        { //RJ Meubels
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [4.7737136, 52.9444070]},
          "properties": {
            "name":"RJ Meubels",
            "phoneFormatted": "+31 223 697 731",
            "phone": "+31223697731",
            "address": "Industrieweg 25",
            "city": "Den Helder",
            "country": "Netherlands",
            "postalCode": "1785 AG",
            "state": "Noord-Holland",
            "web":"www.rjmeubeldiscount.nl/"
          }
        },


        { //Roadz Wonen
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.4322652, 53.1471269]},
          "properties": {
            "name":"Roadz Wonen",
            "phoneFormatted": "+31 503 050 271",
            "phone": "+31503050271",
            "address": "Westeresch  1-5",
            "city": "Roden",
            "country": "Netherlands",
            "postalCode": "9301 ZW",
            "state": "Drenthe",
            "web":"www.roadz.nl"
          }
        },



        { //Scholtens-Antiek
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.5263598, 52.7329125]},
          "properties": {
            "name":"Scholtens-Antiek",
            "phoneFormatted": "+31 528 266 854",
            "phone": "+31528266854",
            "address": "Lindberghstraat 29",
            "city": "Hoogeveen",
            "country": "Netherlands",
            "postalCode": "7903 BM",
            "state": "Drenthe",
            "web":"www.scholtens-antiek.nl"
          }
        },

      

        { //Stokroos Meubels
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.5791002, 53.0114273]},
          "properties": {
            "name":"Stokroos Meubels",
            "phoneFormatted": "+31 640 248 046",
            "phone": "+31640248046",
            "address": "Zeilmakerstraat  26-28",
            "city": "Assen",
            "country": "Netherlands",
            "postalCode": "9403 VA",
            "state": "Drenthe",
            "web":"www.stokroos-meubels.nl"
          }
        },

        { //Straluma
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [4.5489971, 51.8675189]},
          "properties": {
            "name":"Straluma",
            "phoneFormatted": "+31 102 921 026",
            "phone": "+31102921026",
            "address": "Zeemanstraat 17",
            "city": "Barendrecht",
            "country": "Netherlands",
            "postalCode": "2991 XR",
            "state": "Zuid-Holland",
            "web":"www.straluma.nl"
          }
        },


        { //Tafelindustrie
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [7.1565127, 52.3105484]},
          "properties": {
            "name":"Tafelindustrie",
            "phoneFormatted": "+49 59 299 46 633",
            "phone": "+49 59 299 46 633",
            "address": "Am Bahndamm 1",
            "city": "Bad Bentheim",
            "country": "Duitsland",
            "postalCode": "48455",
            "state": "",
            "web":"www.tafelindustrie.de"
          }
        },



         { //THE TEAK HOUSE
            "type": "Feature",
            "geometry": {
              "type": "Point", 
              "coordinates": [6.0113316, 50.6365399]},
            "properties": {
              "name":"THE TEAK HOUSE",
              "phoneFormatted": "+32 87560167",
              "phone": "+3287560167",
              "address": "Handelsstraße 6",
              "city": "Eupen",
              "country": "Belgium",
              "postalCode": "4700",
              "state": "",
              "web":"www.theteakhouse.net"
            }
          },
        

        { //Thuys Deco & Kado
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.5713090, 52.4609150]},
          "properties": {
            "name":"Thuys Deco & Kado",
            "phoneFormatted": "+31 546 785 077",
            "phone": "+31546785077",
            "address": "Amaliaplein 6",
            "city": "Vroomshoop",
            "country": "Nederland",
            "postalCode": "7681 MG",
            "state": "Gelderland",
            "web":"www.welkomthuys.nl"
          }
        },


        { //Trendwood
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [3.2021653, 50.9070142]},
          "properties": {
            "name":"Trendwood",
            "phoneFormatted": "+32 51 302 000",
            "phone": "+32 51 302 000",
            "address": "Meensesteenweg 51",
            "city": "Izegem",
            "country": "België",
            "postalCode": "8870",
            "state": "",
            "web":"www.trendwood.be"
          }
        },


        { //Trendy Woodshop 
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [5.5441920, 52.3308869]},
          "properties": {
            "name":"Trendy Woodshop",
            "phoneFormatted": "+31 640 152 269",
            "phone": "+31640152269",
            "address": "Weergang  5-7",
            "city": "Zeewolde",
            "country": "Nederland",
            "postalCode": "3891 GR",
            "state": "Flevoland"
          }
        },


        { //Uniqueroom GmbH
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [7.4658570, 47.0046916]},
          "properties": {
            "name":"Uniqueroom GmbH",
            "phoneFormatted": "+41 31 515 66 88",
            "phone": "+41315156688",
            "address": "industriestrasse 20",
            "city": "Zeewolde",
            "country": "Zwitserland",
            "postalCode": "3052",
            "state": "",
            "web":"www.uniqueroom.ch"
            
          }
        },
        
        { //Spektuin B.V.
           "type": "Feature",
           "geometry": {
             "type": "Point", 
             "coordinates": [4.6101119, 52.0214526]},
           "properties": {
             "name":"Van der Spek Tuincentrum",
             "phoneFormatted": "+31  180 631 511",
             "phone": "+31180631511",
             "address": "Bredeweg  110",
             "city": "Zevenhuizen",
             "country": "Nederland",
             "postalCode": "2761 KB",
             "state": "Zuid-Holland",
             "web":"www.spekvoordeel.nl"
            }
         },

        
        { //Woodindustries
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [4.8692030, 52.1557355]},
          "properties": {
            "name":"Woodindustries",
            "phoneFormatted": "+31 615 356 759",
            "phone": "+31615356759",
            "address": "Amstelkade  1",
            "city": "Woerdense Verlaat",
            "country": "Nederland",
            "postalCode": "3652 MD",
            "state": "Zuid-Holland",
            "web":"www.woodindustries.nl"
          }
        },



        { //Wooonze
          "type": "Feature",
          "geometry": {
            "type": "Point", 
            "coordinates": [6.1978179, 52.2459714]},
          "properties": {
            "name":"Wooonze",
            "phoneFormatted": "+31 638 557 251",
            "phone": "+31638557251",
            "address": "Hannoverstraat 7",
            "city": "Deventer",
            "country": "Nederland",
            "postalCode": "7418 BL",
            "state": "Overijssel",
            "web":"www.wooonze.nl"
          }
        },


    
      ]
    };




      /**
       * Assign a unique id to each store. You'll use this `id`
       * later to associate each point on the map with a listing
       * in the sidebar.
       */
      stores.features.forEach((store, i) => {
        store.properties.id = i;
      });

      /**
       * Wait until the map loads to make changes to the map.
       */
      map.on('load', () => {
        /**
         * This is where your '.addLayer()' used to be, instead
         * add only the source without styling a layer
         */
        map.addSource('places', {
          'type': 'geojson',
          'data': stores
        });



        /**
         * Create a new MapboxGeocoder instance.
         */
        const geocoder = new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          mapboxgl: mapboxgl,
          marker: true,
          bbox: [-4.706011,42.664766,13.747158,54.558128]
        });

        


        
     buildLocationList(stores);
        map.addControl(geocoder, 'top-left');
        addMarkers();




        /**
         * Listen for when a geocoder result is returned. When one is returned:
         * - Calculate distances
         * - Sort stores by distance
         * - Rebuild the listings
         * - Adjust the map camera
         * - Open a popup for the closest store
         * - Highlight the listing for the closest store.
         */
        geocoder.on('result', (event) => {
          /* Get the coordinate of the search result */
          const searchResult = event.result.geometry;

          
 /**
           * Calculate distances:
           * For each store, use turf.disance to calculate the distance
           * in miles between the searchResult and the store. Assign the
           * calculated value to a property called `distance`.
           */
          const options = { units: 'kilometers' };
          for (const store of stores.features) {
            store.properties.distance = turf.distance(
              searchResult,
              store.geometry,
              options
            );
          }


          
          /**
           * Sort stores by distance from closest to the `searchResult`
           * to furthest.
           */
          stores.features.sort((a, b) => {
            if (a.properties.distance > b.properties.distance) {
              return 1;
            }
            if (a.properties.distance < b.properties.distance) {
              return -1;
            }
            return 0; // a must be equal to b
          });


          
          /**
           * Rebuild the listings:
           * Remove the existing listings and build the location
           * list again using the newly sorted stores.
           */
          const listings = document.getElementById('listings');
          while (listings.firstChild) {
            listings.removeChild(listings.firstChild);
          }
          buildLocationList(stores);

          /* Open a popup for the closest store. */
          createPopUp(stores.features[0]);

          /** Highlight the listing for the closest store. */
          const activeListing = document.getElementById(
            `listing-${stores.features[0].properties.id}`
          );
          activeListing.classList.add('active');

          /**
           * Adjust the map camera:
           * Get a bbox that contains both the geocoder result and
           * the closest store. Fit the bounds to that bbox.
           */
          const bbox = getBbox(stores, 0, searchResult);
          map.fitBounds(bbox, {
            padding: 100
          });
        });
      });

      /**
       * Using the coordinates (lng, lat) for
       * (1) the search result and
       * (2) the closest store
       * construct a bbox that will contain both points
       */
      function getBbox(sortedStores, storeIdentifier, searchResult) {
        const lats = [
          sortedStores.features[storeIdentifier].geometry.coordinates[1],
          searchResult.coordinates[1]
        ];
        const lons = [
          sortedStores.features[storeIdentifier].geometry.coordinates[0],
          searchResult.coordinates[0]
        ];
        const sortedLons = lons.sort((a, b) => {
          if (a > b) {
            return 1;
          }
          if (a.distance < b.distance) {
            return -1;
          }
          return 0;
        });
        const sortedLats = lats.sort((a, b) => {
          if (a > b) {
            return 1;
          }
          if (a.distance < b.distance) {
            return -1;
          }
          return 0;
        });
        return [
          [sortedLons[0], sortedLats[0]],
          [sortedLons[1], sortedLats[1]]
        ];
      }



        
      /**
       * Add a marker to the map for every store listing.
       **/
      function addMarkers() {
        /* For each feature in the GeoJSON object above: */
        for (const marker of stores.features) {
          /* Create a div element for the marker. */
          const el = document.createElement('div');
          /* Assign a unique `id` to the marker. */
          el.id = `marker-${marker.properties.id}`;
          /* Assign the `marker` class to each marker for styling. */
          el.className = 'marker';

          /**
           * Create a marker using the div element
           * defined above and add it to the map.
           **/
          new mapboxgl.Marker(el, { offset: [0, -23] })
            .setLngLat(marker.geometry.coordinates)
            .addTo(map);




          
          /**
           * Listen to the element and when it is clicked, do three things:
           * 1. Fly to the point
           * 2. Close all other popups and display popup for clicked store
           * 3. Highlight listing in sidebar (and remove highlight for all other listings
           **/
          el.addEventListener('click', (e) => {
            /* Fly to the point */
            flyToStore(marker);
            /* Close all other popups and display popup for clicked store */
            createPopUp(marker);
            /* Highlight listing in sidebar */
            const activeItem = document.getElementsByClassName('active');
            e.stopPropagation();
            if (activeItem[0]) {
              activeItem[0].classList.remove('active');
            }
            const listing = document.getElementById(
              `listing-${marker.properties.id}`
            );
            listing.classList.add('active');
          });
        }
      }

      /**
       * Add a listing for each store to the sidebar.
       **/
      function buildLocationList(stores) {
        for (const store of stores.features) {
          /* Add a new listing section to the sidebar. */
          const listings = document.getElementById('listings');
          const listing = listings.appendChild(document.createElement('div'));
          /* Assign a unique `id` to the listing. */
          listing.id = `listing-${store.properties.id}`;
          /* Assign the `item` class to each listing for styling. */
          listing.className = 'item';
          

          /* Add the link to the individual listing created above. */
          const link = listing.appendChild(document.createElement('div'));
          link.href = '#';
          link.className = 'h5';
          link.id = `link-${store.properties.id}`;
          link.innerHTML = `${store.properties.name}`;

          /* Add details to the individual listing. */
          const details = listing.appendChild(document.createElement('div'));
          details.innerHTML = `<p>${store.properties.address}</p><p>${store.properties.postalCode} ${store.properties.city}</p>`;
          if (store.properties.phone) {
            details.innerHTML += `<p>${store.properties.phoneFormatted}</p>`; 
          }
        
          if (store.properties.web) {
            details.innerHTML += `<a href="https://${store.properties.web}" target="_blank" rel="noreferrer noopener"  class="web">${store.properties.web}</a>`; 
          }


           
          
          if (store.properties.distance) {
            const roundedDistance =
              Math.round(store.properties.distance * 100) / 100;
            details.innerHTML += `<p>${roundedDistance} kilometer</p>`;
          }
        


          


          /**
           * Listen to the element and when it is clicked, do four things:
           * 1. Update the `currentFeature` to the store associated with the clicked link
           * 2. Fly to the point
           * 3. Close all other popups and display popup for clicked store
           * 4. Highlight listing in sidebar (and remove highlight for all other listings)
           **/
         link.addEventListener('click', function () {
            for (const feature of stores.features) {
              if (this.id === `link-${feature.properties.id}`) {
                flyToStore(feature);
                createPopUp(feature);
              }
            }
            const activeItem = document.getElementsByClassName('active');
            if (activeItem[0]) {
              activeItem[0].classList.remove('active');
            }
            this.parentNode.classList.add('active');
          });
        }
      }

      /**
       * Use Mapbox GL JS's `flyTo` to move the camera smoothly
       * a given center point.
       **/
      function flyToStore(currentFeature) {
        map.flyTo({
          center: currentFeature.geometry.coordinates,
          zoom: 13
        });
      }


      
      /**
       * Create a Mapbox GL JS `Popup`.
       **/
      function createPopUp(currentFeature) {
        const popUps = document.getElementsByClassName('mapboxgl-popup');
        if (popUps[0]) popUps[0].remove();
        const popup = new mapboxgl.Popup({ closeOnClick: false })
          .setLngLat(currentFeature.geometry.coordinates)
          .setHTML(
           `<div class="h5">${currentFeature.properties.name}</div>
            <div><p>${currentFeature.properties.address}</p>
            <p>${currentFeature.properties.postalCode} ${currentFeature.properties.city}</p></div>`
          )

          
          .addTo(map);
      }

}

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}








// window.onload = () => {
//     //write your code here


// mapboxgl.accessToken = 'pk.eyJ1IjoiYmVub2EiLCJhIjoiY2xsdXFwM3QyMW4ydDNkcDhrNWlieXE4cyJ9.VEeinK3SAn8uqvX_5Nn4ZA';

//       /**
//        * Add the map to the page
//        */
//       const map = new mapboxgl.Map({
//         container: 'map',
//         style: 'mapbox://styles/benoa/cllv0j6ud00dr01qx3jrx5fgr',
//         center: [4.410321,52.307425],
//         zoom: 7,
//         scrollZoom: false,
//         maxZoom: 14,
//         minZoom:6

//         // center: [5.1097865,52.089248999999995],
        
        
//     });

//     const nav = new mapboxgl.NavigationControl({
// // visualizePitch: false,
// // showCompass:false
      
// });

  
//   map.addControl(new mapboxgl.NavigationControl());



  
//     const stores = {
//      "type": "FeatureCollection",
//       "features": [
        
//            { //Appels Design
//             "type": "Feature",
//             "geometry": {
//               "type": "Point", 
//               "coordinates": [6.845230, 52.221370]},
//             "properties": {
//               "name":"Appels Design",
//               "phoneFormatted": "+31 622 402 880",
//               "phone": "+31622402880",
//               "address": "De Ossenboer 26",
//               "city": "Enschede",
//               "country": "Netherlands",
//               "postalCode": "7547 SJ",
//               "state": "Overijssel",
//               "web":"www.appelsdesign.nl"
//             }
//           },

        
//            { //Arc Living
//             "type": "Feature",
//             "geometry": {
//               "type": "Point", 
//               "coordinates": [5.943806, 51.878482 ]},
//             "properties": {
//               "name":"Arc Living",
//               "phoneFormatted": "+31 622 993 131",
//               "phone": "+31622993132",
//               "address": "Langstraat 277",
//               "city": "Gendt",
//               "country": "Netherlands",
//               "postalCode": "6691 EE",
//               "state": "Overijssel",
//               "web":"www.arc-living.nl"
//             }
//           },

//            { //ASN Nature & Living 
//             "type": "Feature",
//             "geometry": {
//               "type": "Point", 
//               "coordinates": [5.1737692, 52.3918513]},
//             "properties": {
//               "name":"ASN Nature & Living",
//               "phoneFormatted": "+31 610 950 958",
//               "phone": "+31610950958",
//               "address": "Loggerzeil 1",
//               "city": "Almere",
//               "country": "Netherlands",
//               "postalCode": "1319 EA",
//               "state": "Noord-Holland",
//               "web":"www.asnnatureandliving.nl"
//             }
//           },

        
//         { //ASN Nature & Living / Loods 5 / Zaandam
//             "type": "Feature",
//             "geometry": {
//               "type": "Point", 
//               "coordinates": [4.8240436, 52.4295682]},
//             "properties": {
//               "name":"ASN Nature & Living / Loods 5",
//               "phoneFormatted": "+31 610 950 958",
//               "phone": "+31610950958",
//               "address": "Pieter Ghijsenlaan 14b",
//               "city": "Zaandam",
//               "country": "Netherlands",
//               "postalCode": "1506 PV",
//               "state": "Noord-Holland",
//               "web":"www.asnnatureandliving.nl"
//             }
//           },

       

//         { //ASN Nature & Living  / Loods 5 / Sliedrecht
//             "type": "Feature",
//             "geometry": {
//               "type": "Point", 
//               "coordinates": [5.4098712, 52.1906543]},
//             "properties": {
//               "name":"ASN Nature & Living / Loods 5",
//               "phoneFormatted": "+31 610 950 958",
//               "phone": "+31610950958",
//               "address": "Leeghwaterstraat 69",
//               "city": "Sliedrecht",
//               "country": "Netherlands",
//               "postalCode": "3364 AE",
//               "state": "Zuid-Holland",
//               "web":"www.asnnatureandliving.nl"
//             }
//           },
        
        
        
//         { //ASN Nature & Living  / Loods 5 / Amersfoort
//             "type": "Feature",
//             "geometry": {
//               "type": "Point", 
//               "coordinates": [4.7603366, 51.8298986]},
//             "properties": {
//               "name":"ASN Nature & Living / Loods 5",
//               "phoneFormatted": "+31 610 950 958",
//               "phone": "+31610950958",
//               "address": "Euroweg 1",
//               "city": "Amersfoort",
//               "country": "Netherlands",
//               "postalCode": "3825 AA",
//               "state": "Utrecht",
//               "web":"www.asnnatureandliving.nl"
//             }
//           },

    
//         { //ASN Nature & Living  / Loods 5 / Maastricht
//             "type": "Feature",
//             "geometry": {
//               "type": "Point", 
//               "coordinates": [5.6875868, 50.8572141]},
//             "properties": {
//               "name":"ASN Nature & Living / Loods 5",
//               "phoneFormatted": "+31 610 950 958",
//               "phone": "+31610950958",
//               "address": "Sphinxcour 5",
//               "city": "Maastricht",
//               "country": "Netherlands",
//               "postalCode": "6211 XZ",
//               "state": "Limburg",
//               "web":"www.asnnatureandliving.nl"
//             }
//           },



//    { //B&G Meubelen
//            "type": "Feature",
//            "geometry": {
//              "type": "Point", 
//              "coordinates": [6.0475425, 52.3447941]},
//            "properties": {
//              "name":"B&G Meubelen",
//              "phoneFormatted": "+31 578 641 200",
//              "phone": "+31578641200",
//              "address": "Houtweg 18",
//              "city": "Oene",
//              "country": "Netherlands",
//              "postalCode": "8167 PL",
//              "state": "Gelderland",
//              "web":"www.bengmeubelen.nl"
//            }
//           },        


//     { //Bergsma Meubelen
//             "type": "Feature",
//             "geometry": {
//               "type": "Point", 
//               "coordinates": [6.0566083, 53.0107877]},
//             "properties": {
//               "name":"Bergsma Meubelen",
//               "phoneFormatted": "+31 64 244 892",
//               "phone": "+3164 44892",
//               "address": "Overtoom 4",
//               "city": "Gorredijk",
//               "country": "Netherlands",
//               "postalCode": "8401 JD",
//               "state": "Friesland",
//               "web":"www.bergsmameubelen.nl"
//             }
//           },


     
        

        
        
//         { //Brouwer Meubelen
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [4.814485, 52.664465]},
//           "properties": {
//             "name":"Brouwer Meubelen",
//             "phoneFormatted": "+31 725 741 160",
//             "phone": "+31725741160",
//             "address": "G. Rietveldweg 3",
//             "city": "Heerhugowaard",
//             "country": "Netherlands",
//             "postalCode": "1703 DD",
//             "state": "Noord-Holland",
//             "web":"www.brouwermeubelen.nl"
//           }
//         },


//        { //Budget Home Store Winterswijk
//             "type": "Feature",
//             "geometry": {
//               "type": "Point", 
//               "coordinates": [6.7049564, 51.9719195]},
//             "properties": {
//               "name":"Budget Home Store Winterswijk",
//               "phoneFormatted": "+31 543 515 296",
//               "phone": "+31543515296",
//               "address": "Europalaan 107",
//               "city": "Winterswijk",
//               "country": "Netherlands",
//               "postalCode": "7102 AC",
//               "state": "Gelderland",
//               "web":"www.budgethomestore.nl"
//             }
//           },


//         { //C & T Meubelen
//             "type": "Feature",
//             "geometry": {
//               "type": "Point", 
//               "coordinates": [4.5925066, 52.2859761]},
//             "properties": {
//               "name":"C & T Meubelen",
//               "phoneFormatted": "+31 252 525 290",
//               "phone": "+31252525290",
//               "address": "Hillegommerdijk 325",
//               "city": "Beinsdorp",
//               "country": "Netherlands",
//               "postalCode": "2144 KR",
//               "state": "Noord-Holland",
//               "web":"www.centmeubelen.nl"
//             }
//           },


//         { //Cavetown
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [5.103926, 52.01547]},
//           "properties": {
//             "name":"Cavetown",
//             "phoneFormatted": "+31 850 470 391",
//             "phone": "+31850470391",
//             "address": "Montageweg 11",
//             "city": "Nieuwegein",
//             "country": "Netherlands",
//             "postalCode": "3433 NT",
//             "state": "Utrecht",
//             "web":"www.cavetown.nl"
//           }
//         },

//         { //Cosy Gifts & Living 
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.1854160, 53.1752203]},
//           "properties": {
//             "name":"Cosy Gifts & Living ",
//             "phoneFormatted": "+31 629 314 479",
//             "phone": "+31629314479",
//             "address": "De Wending 5",
//             "city": "Opende",
//             "country": "Netherlands",
//             "postalCode": "9865 VC",
//             "state": "Groningen",
//             "web":"www.cosy-opende.nl"
//           }
//         },


//         { //De Echo Wonen & Slapen
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [5.4187502, 51.4143598]},
//           "properties": {
//             "name":"De Echo Wonen & Slapen",
//             "phoneFormatted": "+31 402 536 377",
//             "phone": "+31402536377",
//             "address": "Provincialeweg 65",
//             "city": "Veldhoven",
//             "country": "Netherlands",
//             "postalCode": "5503 HB",
//             "state": "Noord-Brabant",
//             "web":"www.deecho.nl"
//           }
//         },

  //         { //Dekker Meubelen
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [5.9566862, 52.2133158]},
//           "properties": {
//             "name":"Dekker Meubelen",
//             "phoneFormatted": "+31 555 214 087",
//             "phone": "+31555214087",
//             "address": "Asselsetstraat 53",
//             "city": "Apeldoorn",
//             "country": "Netherlands",
//             "postalCode": "7311 ED",
//             "state": "Gelderland",
//             "web":"www.dekkermeubelen.nl"
//           }
//         },      

//         { //De Meubelstunter
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.9173207, 52.7708552]},
//           "properties": {
//             "name":"De Meubelstunter",
//             "phoneFormatted": "+31 651 555 269",
//             "phone": "+31651555269",
//             "address": "Kapitein Grantstraat 32",
//             "city": "Emmen",
//             "country": "Netherlands",
//             "postalCode": "7821 AR",
//             "state": "Drenthe",
//           }
//         },

//        { //De Tuin van Eden
//          "type": "Feature",
//          "geometry": {
//            "type": "Point", 
//            "coordinates": [4.5806245, 51.3904614]},
//          "properties": {
//            "name":"De Tuin van Eden",
//            "phoneFormatted": "+32 476 638 526",
//            "phone": "+32476638526",
//            "address": "Kalmhoutsesteenweg 112",
//            "city": "Wuustwezel",
//            "country": "Belgium",
//            "postalCode": "2990",
//            "web":"www.detuinvaneden.com"
//          }
//        },
     
//        { //De Pottentuin
//          "type": "Feature",
//          "geometry": {
//            "type": "Point", 
//            "coordinates": [4.7401152, 51.3023005]},
//          "properties": {
//            "name":"De Pottentuin",
//            "phoneFormatted": "+32 485 570 248",
//            "phone": "+32485870248",
//            "address": "Blijkerijstraat 63",
//            "city": "Malle",
//            "country": "Belgium",
//            "postalCode": "2390",
//            "web":"www.depottentuin.be"
//          }
//        },


//         { //De Woonhoek
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [5.4753935, 51.4686718]},
//           "properties": {
//             "name":"De Woonhoek",
//             "phoneFormatted": "+31 402 871 200",
//             "phone": "+31402871200",
//             "address": "Winkelcentrum Woensel 342",
//             "city": "Eindhoven",
//             "country": "Netherlands",
//             "postalCode": "5625 AG",
//             "state": "Noord-Brabant",
//             "web":"www.dewoonhoek.nl"
//           }
//         },


//         { //Dilay Wonen en Slapen
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [5.4771163, 51.4517946]},
//           "properties": {
//             "name":"Dilay Wonen en Slapen",
//             "phoneFormatted": "+31 40 751 0043",
//             "phone": "+31407510043",
//             "address": "Veldmaarschalk Montgomerylaan 669",
//             "city": "Eindhoven",
//             "country": "Netherlands",
//             "postalCode": "5612 BP",
//             "state": "Noord-Brabant",
//             "web":"www.dilaywonen.nl"
//           }
//         },

//         { //EPD Meubels
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [4.5851819, 51.5683623]},
//           "properties": {
//             "name":"EPD Meubels",
//             "phoneFormatted": "+31 615 254 70",
//             "phone": "+3161525470",
//             "address": "Korte Bunder 17",
//             "city": "Hoeven",
//             "country": "Netherlands",
//             "postalCode": "4741 TV",
//             "state": "Noord-Brabant",
//             "web":"www.epdmeubels.nl"
//           }
//         },
        
        
//         { //Fameus wonen
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [4.7691588, 52.9449879]},
//           "properties": {
//             "name":"Fameus wonen",
//             "phoneFormatted": "+31 223 634 910",
//             "phone": "+31223634910",
//             "address": "Industrieweg 7",
//             "city": "Den Helder",
//             "country": "Netherlands",
//             "postalCode": "1785 AG",
//             "state": "Noord-Holland",
//             "web":"www.fameuswonen.nl"
//           }
//         },

//         { //Frenque Interiors BV
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [7.0098487, 52.2503525]},
//           "properties": {
//             "name":"Frenque Interiors",
//             "phoneFormatted": "+31 534 368 173",
//             "phone": "+31534368173",
//             "address": "Nijverheidstraat 11",
//             "city": "Losser",
//             "country": "Netherlands",
//             "postalCode": "7581 PV",
//             "state": "Overijssel",
//             "web":"www.frenque.nl"
      
//           }
//         },

//         { //Gert Willigenburg Wonen & Lifestyle
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [5.4817452, 52.2369598]},
//           "properties": {
//             "name":"Gert Willigenburg Wonen & Lifestyle",
//             "phoneFormatted": "+31 337 410 220",
//             "phone": "+31337410220",
//             "address": "Handelsweg 30",
//             "city": "Putten",
//             "country": "Netherlands",
//             "postalCode": "3881 LS",
//             "state": "Gelderland",
//             "web":"www.gertwilligenburg.nl"
//           }
//         },

//         { //geWOON!
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [5.9177805, 52.5571443]},
//           "properties": {
//             "name":"geWOON!",
//             "phoneFormatted": "+31 820 202 627",
//             "phone": "+31820202627",
//             "address": "Oudestraat 76",
//             "city": "Kampen",
//             "country": "Netherlands",
//             "postalCode": "8261 CT",
//             "state": "Overijssel",
//             "web":"www.gewoonkampen.nl"
//           }
//         },


//         { //Goedkoopste woonwinkel
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [4.7551329, 51.8316504]},
//           "properties": {
//             "name":"Goedkoopste Woonwinkel",
//             "phoneFormatted": "+31 648 646 376",
//             "phone": "+31648646376",
//             "address": "Marisstraat 12",
//             "city": "Sliedrecht",
//             "country": "Netherlands",
//             "postalCode": "3364 AZ",
//             "state": "Zuid-Holland",
//             "web":"www.goedkoopstewoonwinkel.nl"
//           }
//         },


//         { //GSM Wonen en Slapen
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.5437170, 52.2980581]},
//           "properties": {
//             "name":"GSM Wonen en Slapen",
//             "phoneFormatted": "+31 548 517 306",
//             "phone": "+31548517306",
//             "address": "Enterstraat 200",
//             "city": "Rijssen",
//             "country": "Netherlands",
//             "postalCode": "7461 PE",
//             "state": "Overijssel" 
//           }
//         },

//         { //Harrie XL
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.0249274, 51.2048352]},
//           "properties": {
//             "name":"Harrie XL!",
//             "phoneFormatted": "+31 493 697 211",
//             "phone": "+31493697211",
//             "address": "Sint Wirosingel 194",
//             "city": "Roermond",
//             "country": "Netherlands",
//             "postalCode": "6042 KZ",
//             "state": "Limburg",
//             "web":"www.webshop.harriexloutlet.nl"
//           }
//         },

//         { //Het Teakmagazijn
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [4.6639593, 52.0252947]},
//           "properties": {
//             "name":"Het Teakmagazijn",
//             "phoneFormatted": "+31 627 627 005",
//             "phone": "+31627627005",
//             "address": "Kanaaldijk 32a",
//             "city": "Waddinxveen",
//             "country": "Netherlands",
//             "postalCode": "2741 PA",
//             "state": "Zuid-Holland",
//             "web":"www.teakmagazijn.nl"
//           }
//         },

//         { //Home Destock
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [3.3969601, 50.373776]},
//           "properties": {
//             "name":"Home Destock",
//             "phoneFormatted": "+32 51 302 000",
//             "phone": "+339 88 50 41 17",
//             "address": "Meensesteenweg 51",
//             "city": "Wallers",
//             "country": "France",
//             "postalCode": "59135",
//             "state": "",
//             "web":""
//           }
//         },




//         { //Houten Meubel Outlet
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [4.8924402, 52.7611081]},
//           "properties": {
//             "name":"Houten Meubel Outlet",
//             "phoneFormatted": "+31 224 850 926",
//             "phone": "+31224850926",
//             "address": "Zandwilg 21-22",
//             "city": "Winkel",
//             "country": "Netherlands",
//             "postalCode": "1731 LS",
//             "state": "Noord-Holland",
//             "web":"www.houtenmeubeloutlet.nl"
//           }
//         },


//         { //Intens Wonen
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [5.185530, 51.585040]},
//           "properties": {
//             "name":"Intens Wonen",
//             "phoneFormatted": "+31 852 010 242",
//             "phone": "+31852010242",
//             "address": "Sprendlingenstraat 9",
//             "city": "Oisterwijk",
//             "country": "Netherlands",
//             "postalCode": "5061 KM",
//             "state": "Noord-Brabant",
//             "web":"www.intenswonen.nl"
//           }
//         },

//         { //Interieurhuus op Ees
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.8022901, 52.9055842]},
//           "properties": {
//             "name":"Interieurhuus op Ees",
//             "phoneFormatted": "+31 655 372 935",
//             "phone": "+31655372935",
//             "address": "Schoolstraat 8",
//             "city": "Ees",
//             "country": "Netherlands",
//             "postalCode": "9536 TC",
//             "state": "Drenthe"
//           }
//         },


//         // { //Koopcentrum 't Zuid
//         //   "type": "Feature",
//         //   "geometry": {
//         //     "type": "Point", 
//         //     "coordinates": [6.0985960, 53.0871330]},
//         //   "properties": {
//         //     "name":"Koopcentrum 't Zuid",
//         //     "phoneFormatted": "+31 512 512 156",
//         //     "phone": "+31 512 512 156",
//         //     "address": "Het Zuid 24a",
//         //     "city": "Drachten",
//         //     "country": "Netherlands",
//         //     "postalCode": "9203 TD",
//         //     "state": "Friesland",
//         //     "web":"www.koopcentrumhetzuid.nl"
//         //   }
//         // },

     

//         { //Kospa Living
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.6428076, 52.3405673]},
//           "properties": {
//             "name":"Kospa Living",
//             "phoneFormatted": "+31 546 648 003",
//             "phone": "+31546648003",
//             "address": "Woonboulevard 18",
//             "city": "Almelo",
//             "country": "Netherlands",
//             "postalCode": "7606 JA",
//             "state": "Gelderland",
//             "web":"www.kospa.nl"
//           }
//         },

//         { //L’ abcd’ aire
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [2.393264, 50.6568626]},
//           "properties": {
//             "name":"L’ abcd’ aire",
//             "phoneFormatted": "+33 3 21 12 65 80",
//             "phone": "+33 3 21 12 65 80",
//             "address": "Route departementale 943 RD",
//             "city": "Aire-sur-la-lys",
//             "country": "France",
//             "postalCode": "62120",
//             "state": "",
//             "web":"www.abcd-aire.fr/"
//           }
//         },


        
//         { //Les Brocanteurs
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.4314443, 52.5281006]},
//           "properties": {
//             "name":"Les Brocanteurs",
//             "phoneFormatted": "+31 653 107 183",
//             "phone": "+31653107183",
//             "address": "Slagenkampweg 5",
//             "city": "Ommen",
//             "country": "Netherlands",
//             "postalCode": "7731 TK",
//             "state": "Overijssel",
//             "web":"www.lesbrocanteurs.nl"
//           }
//         },


//         { //Lito Meubelen
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.8669701, 52.2194398]},
//           "properties": {
//             "name":"Lito Meubelen",
//             "phoneFormatted": "+31 629 581 125",
//             "phone": "+31653107183",
//             "address": "Parkweg 155",
//             "city": "Enschede",
//             "country": "Netherlands",
//             "postalCode": "7545 MV",
//             "state": "Overijssel",
//             "web":"www.leukemeubels.nl"
//           }
//         },



//        { //Loft16 
//          "type": "Feature",
//          "geometry": {
//            "type": "Point", 
//            "coordinates": [3.9909176,51.2730394]},
//          "properties": {
//            "name":"Loft16",
//            "phoneFormatted": "+31 646 712 564 ",
//            "phone": "+31646712564",
//            "address": "Industrieweg 2 ",
//            "city": "Hulst",
//            "country": "Netherlands",
//            "postalCode": "4561 GH",
//            "state": "Zeeland",
//            "web":"www.loft16.nl"
//          }
//        },



//         { //Mangohoutenmeubels
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [4.6424006, 52.37050817]},
//           "properties": {
//             "name":"Mangohoutenmeubels ",
//             "phoneFormatted": "+31 614 161 242",
//             "phone": "++31 614 161 242",
//             "address": "Clothildestraat 267",
//             "city": "Haarlem",
//             "country": "Netherlands",
//             "postalCode": "2033 LW",
//             "state": "Noord-Holland",
//             "web":"www.mangohoutenmeubels.nl"
//           }
//         },


//         { //Cows & More Decorations / Met Meubels
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [4.6635907, 51.8084264]},
//           "properties": {
//             "name":"Met Meubels",
//             "phoneFormatted": "+31 622 078 616",
//             "phone": "+31622078616",
//             "address": "Burg. de Raadsingel 95a",
//             "city": "Dordrecht",
//             "country": "Netherlands",
//             "postalCode": "3311 JG",
//             "state": "Zuid-Holland",
//             "web":"www.metmeubels.nl"
//           }
//         },


//         { //Meubel Outletstore Veendam
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.8869147, 53.1047927]},
//           "properties": {
//             "name":"Meubel Outletstore Veendam",
//             "phoneFormatted": "+31 625 211 980",
//             "phone": "+31625211980",
//             "address": "Spoorweg 10a",
//             "city": "Veendam",
//             "country": "Netherlands",
//             "postalCode": "9641 KH",
//             "state": "Groningen"
//           }
//         },


//         { //Meubelbaas
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [5.9721550, 52.2263190]},
//           "properties": {
//             "name":"Meubelbaas",
//             "phoneFormatted": "+31 850 608 569",
//             "phone": "+31850608569",
//             "address": "Vlijtseweg  134-HAL18",
//             "city": "Apeldoorn",
//             "country": "Netherlands",
//             "postalCode": "7317 AK",
//             "state": "Groningen",
//             "web":"www.meubelbaas.nl"
//           }
//         },



//         { //Meubelplaats.nl
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.1589286, 52.2641297]},
//           "properties": {
//             "name":"Meubelplaats.nl",
//             "phoneFormatted": "+31 570 763 763",
//             "phone": "+31570763763",
//             "address": "Ceintuurbaan 209",
//             "city": "Deventer",
//             "country": "Nederland",
//             "postalCode": "7413 DE",
//             "state": "Overijssel",
//             "web":"www.meubelplaats.nl"
//           }
//         },



//      { //Meubelstudio van Haren
//          "type": "Feature",
//          "geometry": {
//            "type": "Point", 
//            "coordinates": [5.9483645, 51.6488097]},
//          "properties": {
//            "name":"Meubelstudio van Haren ",
//            "phoneFormatted": "+31 485 575 146",
//            "phone": "+31485575146",
//            "address": "De Reatsingel 2A",
//            "city": "Boxmeer",
//            "country": "Netherlands",
//            "postalCode": "5831 KC",
//            "state": "Noord-Brabant",
//            "web":"www.meubelstudiovanharen.nl"
//          }
//        },


//         { //Mokana Meubelen
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.9098070, 52.2145952]},
//           "properties": {
//             "name":"Mokana Meubelen",
//             "phoneFormatted": "+31 534 335 032",
//             "phone": "+31534335032",
//             "address": "Hogelandsingel 49",
//             "city": "Enschede",
//             "country": "Netherlands",
//             "postalCode": "7512 GB",
//             "state": "Overijssel",
//             "web":"www.mokana.nl"
//           }
//         },


//         { //Onje Clonje
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [5.6683143, 51.4946036]},
//           "properties": {
//             "name":"Onje Clonje",
//             "phoneFormatted": "+31 655 851 972",
//             "phone": "+31655851972",
//             "address": "Nieuwveld 49B",
//             "city": "Helmond",
//             "country": "Netherlands",
//             "postalCode": "5702 HW",
//             "state": "Utrecht"
//           }
//         },


//         { //Onze Teakhoek
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [5.1025106, 52.0627556]},
//           "properties": {
//             "name":"Onze Teakhoek",
//             "phoneFormatted": "+31 302 805 035",
//             "phone": "+31302805035",
//             "address": "Zeelantlaan 25",
//             "city": "Utrecht",
//             "country": "Netherlands",
//             "postalCode": "3526 AK",
//             "state": "Utrecht",
//             "web":"www.onzeteakhoek.nl"
//           }
//         },

        
//         { //Peerz Living & Lifestyle
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [5.4467282, 51.6069951]},
//           "properties": {
//             "name":"Peerz Living & Lifestyle",
//             "phoneFormatted": "+31 733 030 078",
//             "phone": "+31733030078",
//             "address": "Rooiseweg 1",
//             "city": "Schijndel",
//             "country": "Netherlands",
//             "postalCode": "5481 SJ",
//             "state": "Noord-Brabant"
//           }
//         },


//         { //Polder Teak
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [5.7062722, 52.4610782]},
//           "properties": {
//             "name":"Polder Teak",
//             "phoneFormatted": "+31 636 002 627",
//             "phone": "+31636002627",
//             "address": "Ploegschaar 52A",
//             "city": "Biddinghuizen",
//             "country": "Netherlands",
//             "postalCode": "8526 SM",
//             "state": "Flevoland",
//             "web":"www.polderteak.nl"
//           }
//         },

//         { // Pura Vida
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [-1.0405572, 38.3984242]},
//           "properties": {
//             "name":"Pura Vida",
//             "phoneFormatted": "+34685616030",
//             "phone": "+34685616030",
//             "address": "Calle Principe de Asturias 10C",
//             "city": "Pinoso",
//             "country": "Spain",
//             "postalCode": "03650",
//             "web":"www.puravidapinoso.eu"
//           }
//         },


//         { //Reas Wonen
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.691670, 52.749780]},
//           "properties": {
//             "name":"REAS WONEN",
//             "phoneFormatted": "+31 524 504 040",
//             "phone": "+31524504040",
//             "address": "Dorpstraat 23",
//             "city": "Gees",
//             "country": "Netherlands",
//             "postalCode": "7863 PA",
//             "state": "Drenthe",
//             "web":"www.reaswonen.nl"
//           }
//         },

        
        
//         { //Ries Meubelen
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [5.3934938, 52.1618302]},
//           "properties": {
//             "name":"Ries Meubelen",
//             "phoneFormatted": "+31 334 720 067",
//             "phone": "+31334720067",
//             "address": "Van Brakelstraat 4",
//             "city": "Amersfoort",
//             "country": "Netherlands",
//             "postalCode": "3814 RK",
//             "state": "Utrecht",
//             "web":"www.riesmeubelen.nl"
//           }
//         },

        
//         { //Rimeni Creatief
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [5.8669335, 50.9979056]},
//           "properties": {
//             "name":"Rimeni Creatief",
//             "phoneFormatted": "+31 612 653 539",
//             "phone": "+31612653539",
//             "address": "Walstraat 37",
//             "city": "Sittard",
//             "country": "Netherlands",
//             "postalCode": "6131 CV",
//             "state": "Limburg",
//             "web":"www.rimenicreatief.nl"
//           }
//         },

        
//         { //RJ Meubels
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [4.7737136, 52.9444070]},
//           "properties": {
//             "name":"RJ Meubels",
//             "phoneFormatted": "+31 223 697 731",
//             "phone": "+31223697731",
//             "address": "Industrieweg 25",
//             "city": "Den Helder",
//             "country": "Netherlands",
//             "postalCode": "1785 AG",
//             "state": "Noord-Holland",
//             "web":"www.rjmeubeldiscount.nl/"
//           }
//         },


//         { //Roadz Wonen
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.4322652, 53.1471269]},
//           "properties": {
//             "name":"Roadz Wonen",
//             "phoneFormatted": "+31 503 050 271",
//             "phone": "+31503050271",
//             "address": "Westeresch  1-5",
//             "city": "Roden",
//             "country": "Netherlands",
//             "postalCode": "9301 ZW",
//             "state": "Drenthe",
//             "web":"www.roadz.nl"
//           }
//         },




//         { //Scholtens-Antiek
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.5263598, 52.7329125]},
//           "properties": {
//             "name":"Scholtens-Antiek",
//             "phoneFormatted": "+31 528 266 854",
//             "phone": "+31528266854",
//             "address": "Lindberghstraat 29",
//             "city": "Hoogeveen",
//             "country": "Netherlands",
//             "postalCode": "7903 BM",
//             "state": "Drenthe",
//             "web":"www.scholtens-antiek.nl"
//           }
//         },


  


//         { //Stokroos Meubels
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.5791002, 53.0114273]},
//           "properties": {
//             "name":"Stokroos Meubels",
//             "phoneFormatted": "+31 640 248 046",
//             "phone": "+31640248046",
//             "address": "Zeilmakerstraat  26-28",
//             "city": "Assen",
//             "country": "Netherlands",
//             "postalCode": "9403 VA",
//             "state": "Drenthe",
//             "web":"www.stokroos-meubels.nl"
//           }
//         },

//         { //Straluma
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [4.5489971, 51.8675189]},
//           "properties": {
//             "name":"Straluma",
//             "phoneFormatted": "+31 102 921 026",
//             "phone": "+31102921026",
//             "address": "Zeemanstraat 17",
//             "city": "Barendrecht",
//             "country": "Netherlands",
//             "postalCode": "2991 XR",
//             "state": "Zuid-Holland",
//             "web":"www.straluma.nl"
//           }
//         },


//         { //Tafelindustrie
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [7.1565127, 52.3105484]},
//           "properties": {
//             "name":"Tafelindustrie",
//             "phoneFormatted": "+49 59 299 46 633",
//             "phone": "+49 59 299 46 633",
//             "address": "Am Bahndamm 1",
//             "city": "Bad Bentheim",
//             "country": "Duitsland",
//             "postalCode": "48455",
//             "state": "",
//             "web":"www.tafelindustrie.de"
//           }
//         },



//          { //THE TEAK HOUSE
//            "type": "Feature",
//            "geometry": {
//              "type": "Point", 
//              "coordinates": [6.0113316, 50.6365399]},
//            "properties": {
//              "name":"THE TEAK HOUSE",
//              "phoneFormatted": "+32 87560167",
//              "phone": "+3287560167",
//              "address": "Handelsstraße 6",
//              "city": "Eupen",
//              "country": "Belgium",
//              "postalCode": "4700",
//              "state": "",
//              "web":"www.theteakhouse.net"
//            }
//          },

//         { //Thuys Deco & Kado
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.5713090, 52.4609150]},
//           "properties": {
//             "name":"Thuys Deco & Kado",
//             "phoneFormatted": "+31 546 785 077",
//             "phone": "+31546785077",
//             "address": "Amaliaplein 6",
//             "city": "Vroomshoop",
//             "country": "Nederland",
//             "postalCode": "7681 MG",
//             "state": "Gelderland",
//             "web":"www.welkomthuys.nl"
//           }
//         },


//         { //Trendwood
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [3.2021653, 50.9070142]},
//           "properties": {
//             "name":"Trendwood",
//             "phoneFormatted": "+32 51 302 000",
//             "phone": "+32 51 302 000",
//             "address": "Meensesteenweg 51",
//             "city": "Izegem",
//             "country": "België",
//             "postalCode": "8870",
//             "state": "",
//             "web":"www.trendwood.be"
//           }
//         },


//         { //Trendy Woodshop 
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [5.5441920, 52.3308869]},
//           "properties": {
//             "name":"Trendy Woodshop",
//             "phoneFormatted": "+31 640 152 269",
//             "phone": "+31640152269",
//             "address": "Weergang  5-7",
//             "city": "Zeewolde",
//             "country": "Nederland",
//             "postalCode": "3891 GR",
//             "state": "Flevoland"
//           }
//         },


//         { //Uniqueroom GmbH
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [7.4658570, 47.0046916]},
//           "properties": {
//             "name":"Uniqueroom GmbH",
//             "phoneFormatted": "+41 31 515 66 88",
//             "phone": "+41315156688",
//             "address": "industriestrasse 20",
//             "city": "Zeewolde",
//             "country": "Zwitserland",
//             "postalCode": "3052",
//             "state": "",
//             "web":"www.uniqueroom.ch"
//           }
//         },


//          { //Spektuin B.V.
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [4.6101119, 52.0214526]},
//           "properties": {
//             "name":"Van der Spek Tuincentrum",
//             "phoneFormatted": "+31  180 631 511",
//             "phone": "+31180631511",
//             "address": "Bredeweg  110",
//             "city": "Zevenhuizen",
//             "country": "Nederland",
//             "postalCode": "2761 KB",
//             "state": "Zuid-Holland",
//             "web":"www.spekvoordeel.nl"
//           }
//         },



//         { //Woodindustries
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [4.8692030, 52.1557355]},
//           "properties": {
//             "name":"Woodindustries",
//             "phoneFormatted": "+31 615 356 759",
//             "phone": "+31615356759",
//             "address": "Amstelkade  1",
//             "city": "Woerdense Verlaat",
//             "country": "Nederland",
//             "postalCode": "3652 MD",
//             "state": "Zuid-Holland",
//             "web":"www.woodindustries.nl"
//           }
//         },




//         { //Wooonze
//           "type": "Feature",
//           "geometry": {
//             "type": "Point", 
//             "coordinates": [6.1978179, 52.2459714]},
//           "properties": {
//             "name":"Wooonze",
//             "phoneFormatted": "+31 638 557 251",
//             "phone": "+31638557251",
//             "address": "Hannoverstraat 7",
//             "city": "Deventer",
//             "country": "Nederland",
//             "postalCode": "7418 BL",
//             "state": "Overijssel",
//             "web":"www.wooonze.nl"
//           }
//         },

    
        
     
        
    
//       ]
//     };




//       /**
//        * Assign a unique id to each store. You'll use this `id`
//        * later to associate each point on the map with a listing
//        * in the sidebar.
//        */
//       stores.features.forEach((store, i) => {
//         store.properties.id = i;
//       });

//       /**
//        * Wait until the map loads to make changes to the map.
//        */
//       map.on('load', () => {
//         /**
//          * This is where your '.addLayer()' used to be, instead
//          * add only the source without styling a layer
//          */
//         map.addSource('places', {
//           'type': 'geojson',
//           'data': stores
//         });



//         /**
//          * Create a new MapboxGeocoder instance.
//          */
//         const geocoder = new MapboxGeocoder({
//           accessToken: mapboxgl.accessToken,
//           mapboxgl: mapboxgl,
//           marker: true,
//           bbox: [-4.706011,42.664766,13.747158,54.558128]
//         });

        


        
//      buildLocationList(stores);
//         map.addControl(geocoder, 'top-left');
//         addMarkers();




//         /**
//          * Listen for when a geocoder result is returned. When one is returned:
//          * - Calculate distances
//          * - Sort stores by distance
//          * - Rebuild the listings
//          * - Adjust the map camera
//          * - Open a popup for the closest store
//          * - Highlight the listing for the closest store.
//          */
//         geocoder.on('result', (event) => {
//           /* Get the coordinate of the search result */
//           const searchResult = event.result.geometry;

          
//  /**
//            * Calculate distances:
//            * For each store, use turf.disance to calculate the distance
//            * in miles between the searchResult and the store. Assign the
//            * calculated value to a property called `distance`.
//            */
//           const options = { units: 'kilometers' };
//           for (const store of stores.features) {
//             store.properties.distance = turf.distance(
//               searchResult,
//               store.geometry,
//               options
//             );
//           }


          
//           /**
//            * Sort stores by distance from closest to the `searchResult`
//            * to furthest.
//            */
//           stores.features.sort((a, b) => {
//             if (a.properties.distance > b.properties.distance) {
//               return 1;
//             }
//             if (a.properties.distance < b.properties.distance) {
//               return -1;
//             }
//             return 0; // a must be equal to b
//           });


          
//           /**
//            * Rebuild the listings:
//            * Remove the existing listings and build the location
//            * list again using the newly sorted stores.
//            */
//           const listings = document.getElementById('listings');
//           while (listings.firstChild) {
//             listings.removeChild(listings.firstChild);
//           }
//           buildLocationList(stores);

//           /* Open a popup for the closest store. */
//           createPopUp(stores.features[0]);

//           /** Highlight the listing for the closest store. */
//           const activeListing = document.getElementById(
//             `listing-${stores.features[0].properties.id}`
//           );
//           activeListing.classList.add('active');

//           /**
//            * Adjust the map camera:
//            * Get a bbox that contains both the geocoder result and
//            * the closest store. Fit the bounds to that bbox.
//            */
//           const bbox = getBbox(stores, 0, searchResult);
//           map.fitBounds(bbox, {
//             padding: 100
//           });
//         });
//       });

//       /**
//        * Using the coordinates (lng, lat) for
//        * (1) the search result and
//        * (2) the closest store
//        * construct a bbox that will contain both points
//        */
//       function getBbox(sortedStores, storeIdentifier, searchResult) {
//         const lats = [
//           sortedStores.features[storeIdentifier].geometry.coordinates[1],
//           searchResult.coordinates[1]
//         ];
//         const lons = [
//           sortedStores.features[storeIdentifier].geometry.coordinates[0],
//           searchResult.coordinates[0]
//         ];
//         const sortedLons = lons.sort((a, b) => {
//           if (a > b) {
//             return 1;
//           }
//           if (a.distance < b.distance) {
//             return -1;
//           }
//           return 0;
//         });
//         const sortedLats = lats.sort((a, b) => {
//           if (a > b) {
//             return 1;
//           }
//           if (a.distance < b.distance) {
//             return -1;
//           }
//           return 0;
//         });
//         return [
//           [sortedLons[0], sortedLats[0]],
//           [sortedLons[1], sortedLats[1]]
//         ];
//       }



        
//       /**
//        * Add a marker to the map for every store listing.
//        **/
//       function addMarkers() {
//         /* For each feature in the GeoJSON object above: */
//         for (const marker of stores.features) {
//           /* Create a div element for the marker. */
//           const el = document.createElement('div');
//           /* Assign a unique `id` to the marker. */
//           el.id = `marker-${marker.properties.id}`;
//           /* Assign the `marker` class to each marker for styling. */
//           el.className = 'marker';

//           /**
//            * Create a marker using the div element
//            * defined above and add it to the map.
//            **/
//           new mapboxgl.Marker(el, { offset: [0, -23] })
//             .setLngLat(marker.geometry.coordinates)
//             .addTo(map);




          
//           /**
//            * Listen to the element and when it is clicked, do three things:
//            * 1. Fly to the point
//            * 2. Close all other popups and display popup for clicked store
//            * 3. Highlight listing in sidebar (and remove highlight for all other listings)
//            **/
//           el.addEventListener('click', (e) => {
//             /* Fly to the point */
//             flyToStore(marker);
//             /* Close all other popups and display popup for clicked store */
//             createPopUp(marker);
//             /* Highlight listing in sidebar */
//             const activeItem = document.getElementsByClassName('active');
//             e.stopPropagation();
//             if (activeItem[0]) {
//               activeItem[0].classList.remove('active');
//             }
//             const listing = document.getElementById(
//               `listing-${marker.properties.id}`
//             );
//             listing.classList.add('active');
//           });
//         }
//       }

//       /**
//        * Add a listing for each store to the sidebar.
//        **/
//       function buildLocationList(stores) {
//         for (const store of stores.features) {
//           /* Add a new listing section to the sidebar. */
//           const listings = document.getElementById('listings');
//           const listing = listings.appendChild(document.createElement('div'));
//           /* Assign a unique `id` to the listing. */
//           listing.id = `listing-${store.properties.id}`;
//           /* Assign the `item` class to each listing for styling. */
//           listing.className = 'item';

//           /* Add the link to the individual listing created above. */
//           const link = listing.appendChild(document.createElement('a'));
//           link.href = '#';
//           link.className = 'h5';
//           link.id = `link-${store.properties.id}`;
//           link.innerHTML = `${store.properties.name}`;

//           /* Add details to the individual listing. */
//           const details = listing.appendChild(document.createElement('div'));
//           details.innerHTML = `<p>${store.properties.address}</p><p>${store.properties.postalCode} ${store.properties.city}</p>`;
//           if (store.properties.phone) {
//             details.innerHTML += `<p>${store.properties.phoneFormatted}</p>`; 
//           }
        
//           if (store.properties.web) {
//             details.innerHTML += `<p class="web"><a href="https://${store.properties.web}" target="_blank" rel="noreferrer noopener" >${store.properties.web}</a></p>`; 
//           }


           
          
//           if (store.properties.distance) {
//             const roundedDistance =
//               Math.round(store.properties.distance * 100) / 100;
//             details.innerHTML += `<p>${roundedDistance} kilometer</p>`;
//           }
        


          


//           /**
//            * Listen to the element and when it is clicked, do four things:
//            * 1. Update the `currentFeature` to the store associated with the clicked link
//            * 2. Fly to the point
//            * 3. Close all other popups and display popup for clicked store
//            * 4. Highlight listing in sidebar (and remove highlight for all other listings)
//            **/
//          link.addEventListener('click', function () {
//             for (const feature of stores.features) {
//               if (this.id === `link-${feature.properties.id}`) {
//                 flyToStore(feature);
//                 createPopUp(feature);
//               }
//             }
//             const activeItem = document.getElementsByClassName('active');
//             if (activeItem[0]) {
//               activeItem[0].classList.remove('active');
//             }
//             this.parentNode.classList.add('active');
//           });
//         }
//       }

//       /**
//        * Use Mapbox GL JS's `flyTo` to move the camera smoothly
//        * a given center point.
//        **/
//       function flyToStore(currentFeature) {
//         map.flyTo({
//           center: currentFeature.geometry.coordinates,
//           zoom: 13
//         });
//       }


      
// /**
//  * Create a Mapbox GL JS `Popup`.
//  **/
// function createPopUp(currentFeature) {
//   const popUps = document.getElementsByClassName('mapboxgl-popup');
//   if (popUps[0]) popUps[0].remove();
//   const popup = new mapboxgl.Popup({ closeOnClick: false })
//     .setLngLat(currentFeature.geometry.coordinates)
//     .setHTML(
//       `<h6>${currentFeature.properties.name}</h6>
//       <br>
//       <p>${currentFeature.properties.address}</p>
//       <p>${currentFeature.properties.postalCode} ${currentFeature.properties.city}</p>
//       ${currentFeature.properties.web ? `<p>${currentFeature.properties.web}</p>` : ''}
//       `
//     )
//     .addTo(map);
// }

// }

// var links = document.links;
// for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
//   if (links[i].hostname !== window.location.hostname) {
//     links[i].target = '_blank';
//     links[i].rel = 'noreferrer noopener';
//   }
// };
